import MoreLink from './link';
import styles from './styles.less';
import { observer } from 'mobx-react';


function MoreLinks(props) {
    const className = cx(styles.root, props.className);
    return (
        <div className={ className }>
            <header className={ styles.header }>
                <h3 className={ styles.title }>More From { props.showTitle }</h3>
            </header>
            <ul className={ styles.list }>
                { props.links.map((link, i) => (
                    <MoreLink
                        key={ i }
                        link={ link }
                        hoverBackgroundColor={ props.highlightColor }
                        hoverColor={ props.rolloverTextColor }
                    />
                )) }
            </ul>
        </div>
    );
}

MoreLinks.propTypes = {
    highlightColor: React.PropTypes.string,
    links: React.PropTypes.object.isRequired,
    rolloverTextColor: React.PropTypes.string,
    showTitle: React.PropTypes.string.isRequired
};

MoreLinks.defaultProps = {
    highlightColor: '#222222',
    links: [],
    rolloverTextColor: '#FFFFFF'
};


export default observer(MoreLinks);



// WEBPACK FOOTER //
// ./src/show-page/components/more-links/index.js